import {
  RebookErrorModal,
  RebookLoadingScreen,
  useRebookBookingOverlay,
} from "@tenant/flights-rebook";
import type { RebookBookingOverlayProps } from "./types";

export const RebookBookingOverlay = ({
  children,
  ...props
}: RebookBookingOverlayProps) => {
  const { context } = useRebookBookingOverlay({ ...props });

  switch (context.state) {
    case "uninitialized":
      return null;

    case "loading":
      return <RebookLoadingScreen isLoading={true} message={context.message} />;

    case "error":
      return (
        <RebookErrorModal
          error={context.error}
          open={true}
          onDismiss={context.dismissError}
          actions={[{ type: "dismiss" }]}
        />
      );
  }
};
